import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    scale: 1,
  },
  mutations: {
    setScale(state, scale) { state.scale = scale },
  },
  actions: {
  },
  modules: {
  }
})
